export default __webpack_public_path__ + "static/media/Yuk2.d3866488.JPG";